export function generateCorrelationId(prefix = 'corr'): string {
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`;
}

export function newLocalCorrelationId(prefix = 'md'): string {
  return generateCorrelationId(prefix);
}
